/**
 * Cdn Thumbnail Formatter.
 * @param {*} value
 * @param {Object} row
 * @returns {String|*}
 */
window.cndThumbnailFormatter = function(value, row) {
    if (value) {
        return '<img src="' + value + '" alt="" class="rounded" style="max-height: ' + row.cdn_thumbnail_max_height + 'px">';
    }
};
